import React from 'react'
import {useAuth} from "../providers/AuthProvider";
import {useMount} from "react-use";
import {Navigate} from "react-router-dom"
const Dashboard = (props) => {
	const {auth} = useAuth();

	useMount(() => {
		if (auth && auth.isPlatformUser()) {
			return window.location.pathname = "/system";
		}
	})

    return <Navigate to={TB.auth().appropriate()} />;

	return (
		<div className='container py-2'>
			<div className='flex flex-row justify-center'>
			</div>
		</div>
	)
}
export default Dashboard;